/*
 * NuovaGlam — Korean Scalp Revival Bar : cadeaux du lot selon la quantité réelle (04/10/2026).
 * La ligne de la barre garde son sélecteur natif − / + (décision utilisatrice 30/09, standard bundles §6ter).
 * Config des paliers portée par la ligne (propriété privée _ng_sb_cfg, écrite par le formulaire de la fiche) :
 *   {"v": <variant barre>, "tiers": [{"min":1,"gifts":[]},{"min":2,"gifts":[<conditioner>,<mystery>]}]}
 * Défaut (anciennes lignes) = DEFAULT_CFG = offre en ligne au 04/10/2026.
 * Prix du lot : remise automatique Shopify « 2× Scalp Bar » (rien à poser ici).
 * Source de vérité = panier Shopify réel ; idempotent (aucun doublon, aucun cadeau orphelin, quantité 1 par cadeau).
 * Chargé sur la fiche (section ng-sb-product) et par layout/theme.liquid quand le panier contient la barre ou un cadeau.
 * Tracking (mesuré le 04/10/2026) : ajouter les cadeaux par le fetch de la page = 1 clic offre 2 → 3 AddToCart Meta
 * (1 natif + 1 par ligne cadeau). Les mutations des cadeaux passent donc par le fetch d'une iframe vide de même
 * origine, invisible pour l'écouteur Shopify (même méthode que assets/ng-ship-protection.js, standard
 * shopify-atc-tracking.md) : seul l'ATC natif de la barre remonte.
 */
(() => {
  if (window.__ngSbCartSync) return;
  window.__ngSbCartSync = true;
  const DEFAULT_CFG = { v: 58706980929867, tiers: [{ min: 1, gifts: [] }, { min: 2, gifts: [58706982928715, 58706982961483] }] };
  const SOURCE = 'ng-sb-sync';
  const IT = (document.documentElement.lang || '').toLowerCase().startsWith('it');
  const GIFT_KEY = IT ? 'Omaggio' : 'Gift';
  const GIFT_VALUE = IT ? "Incluso nell'offerta" : 'Included with your offer';
  const route = (path) => (window.Shopify?.routes?.root || '/') + path;
  const absolute = (path) => window.location.origin + route(path);
  let rawFetch = null;
  /* fetch non instrumenté (iframe about:blank, même origine, cookies du panier inclus) ; repli = fetch de la page. */
  function cleanFetch() {
    if (rawFetch) return rawFetch;
    try {
      const frame = document.createElement('iframe');
      frame.hidden = true;
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      document.body.appendChild(frame);
      rawFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
    } catch (e) {
      rawFetch = window.fetch.bind(window);
    }
    return rawFetch;
  }

  const readCfg = (lines) => {
    for (const line of lines) {
      try {
        const cfg = JSON.parse(line.properties?._ng_sb_cfg || 'null');
        if (cfg && Array.isArray(cfg.tiers) && cfg.tiers.length) return cfg;
      } catch (e) { /* propriété illisible : défaut */ }
    }
    return DEFAULT_CFG;
  };

  function plan(cart) {
    const items = cart.items || [];
    const cfgLines = items.filter((i) => i.properties && i.properties._ng_sb_cfg);
    const cfg = readCfg(cfgLines);
    const mainVariant = Number(cfg.v) || DEFAULT_CFG.v;
    const allGiftIds = new Set(DEFAULT_CFG.tiers.flatMap((t) => t.gifts).concat(cfg.tiers.flatMap((t) => t.gifts || [])).map(Number));
    const mains = items.filter((i) => i.variant_id === mainVariant);
    const qty = mains.reduce((s, i) => s + i.quantity, 0);
    const tiers = cfg.tiers.map((t) => ({ min: Math.max(1, Number(t.min) || 1), gifts: (t.gifts || []).map(Number).filter(Boolean) })).sort((a, b) => b.min - a.min);
    const tier = qty > 0 ? (tiers.find((t) => qty >= t.min) || { gifts: [] }) : { gifts: [] };
    const gifts = items.filter((i) => i.properties && i.properties._ng_sb_gift);
    const strays = items.filter((i) => allGiftIds.has(i.variant_id) && !(i.properties && i.properties._ng_sb_gift));
    const updates = {};
    const seen = new Set();
    gifts.forEach((g) => {
      if (!tier.gifts.includes(g.variant_id) || seen.has(g.variant_id)) { updates[g.key] = 0; return; }
      seen.add(g.variant_id);
      if (g.quantity !== 1) updates[g.key] = 1;
    });
    strays.forEach((g) => { updates[g.key] = 0; });
    if (Object.keys(updates).length) return { step: 'update', updates };
    /* 14/10/2026 : mention visible sur la ligne cadeau (commande Admin, e-mail, tiroir) pour que l'agent voie qu'il doit l'expédier.
       Libellé neutre, indépendant de la quantité (standard bundles §3ter). */
    const add = tier.gifts.filter((id) => !seen.has(id)).map((id) => ({ id, quantity: 1, properties: { _ng_sb_gift: 'scalp-bar', [GIFT_KEY]: GIFT_VALUE } }));
    return add.length ? { step: 'add', items: add } : null;
  }

  async function readCart() {
    const r = await fetch(route('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' });
    if (!r.ok) throw new Error(`cart ${r.status}`);
    return r.json();
  }
  async function post(path, body) {
    const r = await cleanFetch()(absolute(path), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok || data.status) throw new Error(data.description || data.message || `${path} ${r.status}`);
    return data;
  }

  /* Re-rendu avec le contrat natif CartItems (tiroir + page panier), comme assets/ng-cm-cart-sync.js. */
  async function render(cart) {
    const hosts = ['cart-drawer-items', 'cart-items']
      .map((s) => document.querySelector(s))
      .filter((h) => h && typeof h.getSectionsToRender === 'function')
      .map((host) => ({ host, sections: host.getSectionsToRender() }));
    const drawer = document.querySelector('cart-drawer');
    if (!hosts.length && drawer && typeof drawer.getSectionsToRender === 'function') hosts.push({ host: drawer, sections: drawer.getSectionsToRender().map((s) => ({ id: s.id, section: s.section || s.id, selector: s.selector })) });
    if (!hosts.length) return;
    const ids = [...new Set(hosts.flatMap(({ sections }) => sections.map((s) => s.section)))];
    const r = await fetch(`${route('cart')}?sections=${ids.join(',')}`, { credentials: 'same-origin', cache: 'no-store' });
    if (!r.ok) throw new Error(`sections ${r.status}`);
    const html = await r.json();
    const empty = cart.item_count === 0;
    hosts.forEach(({ host, sections }) => {
      host.classList.toggle('is-empty', empty);
      sections.forEach((s) => {
        const el = document.getElementById(s.id);
        if (!el || typeof html[s.section] !== 'string') return;
        const target = (s.selector && el.querySelector(s.selector)) || el;
        const markup = typeof host.getSectionInnerHTML === 'function'
          ? host.getSectionInnerHTML(html[s.section], s.selector)
          : new DOMParser().parseFromString(html[s.section], 'text/html').querySelector(s.selector || '.shopify-section')?.innerHTML;
        if (typeof markup === 'string') target.innerHTML = markup;
      });
    });
    drawer?.classList.toggle('is-empty', empty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
  }

  async function reconcile() {
    let cart = await readCart();
    let changed = false;
    for (let i = 0; i < 4; i += 1) {
      const next = plan(cart);
      if (!next) break;
      changed = true;
      if (next.step === 'update') cart = await post('cart/update.js', { updates: next.updates });
      else { await post('cart/add.js', { items: next.items }); cart = await readCart(); }
    }
    return changed ? cart : null;
  }

  let queue = Promise.resolve();
  const run = () => {
    queue = queue.then(async () => {
      try {
        const cart = await reconcile();
        if (cart) {
          await render(cart);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
        }
      } catch (e) {
        console.error('[NuovaGlam Scalp Bar cart sync]', e);
      }
    });
    return queue;
  };

  /* Sticky Occlusion + Async Settle (07/10/2026). Le tiroir affiche le produit (et son − / +) avant ses cadeaux
   * (snippets/cart-drawer.liquid). Sur mobile court la liste visible (≈ 210 px) est plus petite que deux cadeaux :
   * sans règle, le défilement pouvait s'arrêter au milieu d'une ligne, son nom caché sous l'en-tête / le bandeau.
   * Quand le tiroir contient des cadeaux Scalp Bar et déborde : (1) chaque ligne est un point d'accroche
   * (scroll-snap) → le défilement s'arrête toujours sur un début de ligne ; (2) l'espace de fin est mesuré à chaque
   * rendu pour que la dernière ligne puisse venir en haut ; (3) après re-render, une ligne coupée en haut est
   * recalée sur son début. Tout est recalculé depuis les hauteurs réelles (MutationObserver, ResizeObserver). */
  function scrollerOf(drawer, row) {
    let sc = row && row.parentElement;
    while (sc && sc !== drawer && !/auto|scroll/.test(getComputedStyle(sc).overflowY)) sc = sc.parentElement;
    return sc && sc !== drawer ? sc : null;
  }
  function revealGifts() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const rows = [...drawer.querySelectorAll('tr.cart-item')];
    const sc = scrollerOf(drawer, rows[0]);
    if (!sc) return;
    const wrap = rows[0].closest('table') || rows[0].parentElement;
    if (sizeWatch) sizeWatch.observe(wrap);                                /* hauteurs réelles : police, retour à la ligne */
    const pad = parseFloat(wrap.style.marginBottom) || 0;
    const on = !!drawer.querySelector('.ng-sb-gift-label') && sc.scrollHeight - pad > sc.clientHeight + 2;
    const head = wrap.querySelector('thead tr');
    sc.style.scrollSnapType = on ? 'y mandatory' : '';
    [head, ...rows].forEach((r) => { if (r) r.style.scrollSnapAlign = on ? 'start' : ''; });
    if (!on) { wrap.style.marginBottom = ''; return; }
    const box = sc.getBoundingClientRect();
    const top = (el) => el.getBoundingClientRect().top - box.top + sc.scrollTop;
    const need = Math.max(0, Math.ceil(top(rows[rows.length - 1]) + sc.clientHeight - (sc.scrollHeight - pad)));
    if (Math.abs(need - pad) > 1) wrap.style.marginBottom = need ? `${need}px` : '';   /* la dernière ligne peut venir en haut */
    const cut = rows.find((r) => { const b = r.getBoundingClientRect(); return b.top < box.top - 1 && b.bottom > box.top + 1; });
    if (!cut) return;
    const act = document.activeElement && document.activeElement !== document.body && sc.contains(document.activeElement) ? document.activeElement.getBoundingClientRect() : null;
    const cb = cut.getBoundingClientRect();
    const up = box.top - cb.top; const down = cb.bottom - box.top;
    const keeps = (shift) => !act || (act.top + shift >= box.top && act.bottom + shift <= box.bottom);
    sc.scrollTop = keeps(up) || !keeps(-down) ? sc.scrollTop - up : sc.scrollTop + down;
  }
  let settleTimer = 0;
  const sizeWatch = typeof ResizeObserver === 'function' ? new ResizeObserver(() => revealSoon()) : null;
  const revealSoon = () => { clearTimeout(settleTimer); settleTimer = setTimeout(() => requestAnimationFrame(revealGifts), 160); };
  const watchDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver !== 'function') return;
    new MutationObserver(revealSoon).observe(drawer, { childList: true, subtree: true });          /* re-render asynchrone */
    new MutationObserver(revealSoon).observe(drawer, { attributes: true, attributeFilter: ['class'] });   /* ouverture */
    if (typeof ResizeObserver === 'function') new ResizeObserver(revealSoon).observe(drawer);           /* rotation, clavier */
  };

  window.NuovaGlamScalpCart = { plan, reconcile, run, idle: () => queue, revealGifts };
  const start = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { if (event?.source !== SOURCE) setTimeout(run, 0); revealSoon(); });
    }
    watchDrawer();
    run();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
